import { c } from 'ttag';

import { DRIVE_APP_NAME } from '@proton/shared/lib/constants';

export const ERROR_REQUIRE_PAGE_REFRESH = c('Error').t`${DRIVE_APP_NAME} has updated. Please refresh the page.`;
